import { defineEvent } from '../types/event';
export var PRODUCT_DETAILS_QUICKVIEW_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_Product_Details_QuickView'
        }
    ]
});
